"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _icon = _interopRequireDefault(require("../icon"));

var _labeled_icon = _interopRequireDefault(require("../labeled_icon"));

var _labeled_flag = _interopRequireDefault(require("../labeled_flag"));

require("../../css/shared/option.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Option = function Option(_ref) {
  var action = _ref.action,
      highlightedRef = _ref.highlightedRef,
      isHighlighted = _ref.isHighlighted,
      isSelected = _ref.isSelected,
      multiple = _ref.multiple,
      onAction = _ref.onAction,
      _onClick = _ref.onClick,
      _onKeyDown = _ref.onKeyDown,
      _onKeyPress = _ref.onKeyPress,
      _onMouseDown = _ref.onMouseDown,
      _onMouseMove = _ref.onMouseMove,
      option = _ref.option;
  var optionClasses = {
    'vn-option': true,
    'vn-option__multiple': multiple,
    'vn-option--disabled': option.disabled,
    'vn-option--highlighted': isHighlighted && !option.disabled,
    'vn-option--selected': isSelected
  };
  var optionActionClasses = {
    'vn-option__action': true,
    'vn-option__action--highlighted': onAction && isHighlighted,
    'vn-option__action--selected': onAction && isSelected
  };
  var href = option.href;
  var aProps = href ? {
    href: href
  } : {};
  return _react.default.createElement("div", {
    className: (0, _classnames.default)(optionClasses),
    "aria-selected": isSelected,
    onClick: function onClick(e) {
      return _onClick(e, option);
    },
    "data-value": option.label || option.value,
    onKeyDown: function onKeyDown(e) {
      return _onKeyDown(e, option);
    },
    onKeyPress: function onKeyPress(e) {
      return _onKeyPress(e);
    },
    onMouseDown: function onMouseDown(e) {
      return _onMouseDown(e, option);
    },
    onMouseEnter: function onMouseEnter(e) {
      return _onMouseMove(e, option);
    },
    onMouseMove: function onMouseMove(e) {
      return _onMouseMove(e, option);
    },
    ref: isHighlighted ? highlightedRef : undefined,
    role: "option",
    tabIndex: 0
  }, multiple && isSelected && !onAction && _react.default.createElement(_icon.default, {
    name: "checkmark",
    size: 24
  }), onAction && _react.default.createElement("div", {
    className: (0, _classnames.default)(optionActionClasses),
    onClick: function onClick(e) {
      return onAction(e, option.value);
    }
  }, "".concat(option.value, " \u2014 "), _react.default.createElement("a", {
    id: "action"
  }, action)), !onAction && _react.default.createElement("a", aProps, option.icon === undefined && option.flag === undefined && (option.label || option.value), option.icon !== undefined && !multiple && _react.default.createElement(_labeled_icon.default, {
    flag: option.flag,
    label: option.label || String(option.value),
    name: option.icon
  }), option.icon === undefined && !multiple && option.flag !== undefined && _react.default.createElement(_labeled_flag.default, {
    label: option.label || String(option.value),
    name: option.flag
  })));
};

Option.propTypes = {
  action: _propTypes.default.string,
  isHighlighted: _propTypes.default.bool,
  isSelected: _propTypes.default.bool,
  multiple: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  onAction: _propTypes.default.func,
  onMouseDown: _propTypes.default.func,
  onMouseMove: _propTypes.default.func,
  onKeyDown: _propTypes.default.func,
  onKeyPress: _propTypes.default.func,
  option: _propTypes.default.shape({
    disabled: _propTypes.default.bool,
    flag: _propTypes.default.string,
    icon: _propTypes.default.string,
    label: _propTypes.default.string,
    value: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]).isRequired
  }).isRequired,
  highlightedRef: _propTypes.default.func
};
Option.defaultProps = {
  action: 'Create New',
  isHighlighted: false,
  isSelected: false,
  multiple: false,
  onClick: function onClick() {},
  onAction: null,
  onKeyDown: function onKeyDown() {},
  onKeyPress: function onKeyPress() {},
  onMouseDown: function onMouseDown() {},
  onMouseMove: function onMouseMove() {},
  highlightedRef: function highlightedRef() {}
};
var _default = Option;
exports.default = _default;